export default {
  title: {
    id: 'price_pickers_title',
    defaultMessage: 'Select gift amount',
  },
  subtitle: {
    id: 'price_pickers_subtitle',
    defaultMessage:
      'The recipient will get a single-use code to use at checkout.',
  },
  text1: {
    id: 'price_pickers_text_1',
    defaultMessage: '1/50 of the latest iPhone',
  },
  text2: {
    id: 'price_pickers_text_2',
    defaultMessage: "A phone case... or real tech if it's refurbished",
  },
  text3: {
    id: 'price_pickers_text_3',
    defaultMessage: 'The iPhone X you wanted',
  },
  text4: {
    id: 'price_pickers_text_4',
    defaultMessage: '1/10 of the latest MacBook Pro',
  },
  customLabel: {
    id: 'price_pickers_custom_label',
    defaultMessage: 'Enter custom amount',
  },
  customAmountError: {
    id: 'price_pickers_custom_amount_error',
    defaultMessage: 'Enter an amount between {minPrice} - {maxPrice}.',
  },
}
